import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, TextInput } from "@opendate-app/setlist";
import { DELIVERY_OPTIONS } from "./DeliveryTab";

const sellsMemberships = (config, membershipProducts) =>
  membershipProducts.some((product) => {
    const membership = (config.memberships || {})[product.id] || {};
    return membership.enabled == null ? product.defaultEnabled : membership.enabled;
  });

const includedRows = (config, settings, membershipProducts) => {
  const names = (config.ticketTypes || []).map((type) => type.name).filter(Boolean);
  const delivery = DELIVERY_OPTIONS.find((option) => option.value === settings.deliveryType);
  return [
    ["Ticket types", names.length ? `${names.length} · ${names.join(", ")}` : "0"],
    ["Add-ons", (config.addOns || []).length],
    ["Holds", (config.holds || []).length],
    ["Kills", (config.kills || []).length],
    ["Promo codes", (config.promoCodes || []).length],
    ["Delivery", delivery && (config.settings || {}).deliveryType ? delivery.name : "Venue default"],
    ["Memberships", sellsMemberships(config, membershipProducts) ? "Sold at checkout" : "Off"],
    ["Settings", "Order limits, check-in and reCAPTCHA"],
  ];
};

const SaveTicketTemplateModal = ({ open, config, settings, membershipProducts, takenNames, saving, error, onSave, onClose }) => {
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");

  React.useEffect(() => {
    if (open) {
      setName("");
      setDescription("");
    }
  }, [open]);

  const trimmed = name.trim();
  const taken = Boolean(trimmed) && takenNames.some((other) => (other || "").toLowerCase() === trimmed.toLowerCase());

  return (
    <Modal
      open={open}
      width={520}
      icon={false}
      title="Save as Ticket Template"
      description="Saves everything on these tabs so you can reuse it on other show types and series."
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!trimmed || taken || saving}
            onClick={() => onSave({ name: trimmed, description: description.trim() })}
          >
            Save Template
          </Button>
        </>
      }
    >
      <div className="series-template-modal">
        <TextInput
          id="ticket-template-name"
          label="Template Name"
          required
          placeholder="e.g., Harvest Weekend Pricing"
          value={name}
          error={taken ? "A template with this name already exists." : error || undefined}
          onChange={(event) => setName(event.target.value)}
        />
        <TextInput
          id="ticket-template-description"
          label="Description (optional)"
          placeholder="What's this template for?"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
        <div className="series-template-includes-title">Includes</div>
        <dl className="series-template-includes">
          {includedRows(config, settings, membershipProducts).map(([label, value]) => (
            <div key={label} className="series-template-includes-row">
              <dt>{label}</dt>
              <dd>{String(value)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </Modal>
  );
};

SaveTicketTemplateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  config: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  membershipProducts: PropTypes.array.isRequired,
  takenNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  saving: PropTypes.bool,
  error: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SaveTicketTemplateModal;
